<template>
<div class="homepageIndia createAccountIndiaPage">
  <!-- <training-header></training-header> -->
  <div class="mdgridviewpage-bg">
    <div class="container-fluid">
      <div class="row pt-2" style="margin:0 !important;">
        <div class="col-2">
          <img src="../assets/img/fplmis/fpss.png" class="d-block m-auto img-fluid">
        </div>
        <div class="col-8">
          <h4 class="align-items-center d-flex h-100 justify-content-center mx-0 text-center text-white loginpageHeading" style="">Family Planning Dashboard</h4>
        </div>
        <div class="col-2">
          <img src="../assets/img/fplmis/nhm.png" class="d-block m-auto img-fluid" style="">
        </div>
      </div>
    </div>
    <div class="container-fluid vertCenter" style="">
      <div class="row dashboardchart-container globalconfigcontainer">
        <div class="col-lg-6 d-flex justify-content-center align-item-center" style="margin:6% auto 4%;">
          <div class="card m-b-20px m-t-20px">

            <ValidationObserver v-slot="{ handleSubmit }">
              <div class="collapse show" aria-labelledby="headingOne">

                <div class="card-body c-body" style="padding-bottom : 10px !important;">
                  <form @submit.prevent="handleSubmit(onSubmit)" class="d-flex">
                    <div class="row col-lg-12" style="margin: 0 auto;">
                      <div class="mainform-holder w-100" style="padding-top: 10px;">
                        <div class="w-100 logoImage">
                          <div class="logoImageDiv">
                            <img src="../assets/img/fplmis/dfc.png" class="d-block m-auto" style="">
                          </div>
                        </div>
                        <h4 class="inner-heading text-center pt-0 pb-3 w-100 mt-3" style="font-weight: 400;">
                          Request for Registration
                        </h4>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-6">
                              <ValidationProvider name="Firstname" rules="required" v-slot="{ errors }">
                                <input v-model.trim="frmAccount['firstname']" type="text" class="form-control bg-grey" placeholder="First Name" />
                                <span class="text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </div>
                            <div class="col-sm-6">
                              <ValidationProvider name="Last Name" rules="required" v-slot="{ errors }">
                                <input v-model.trim="frmAccount['lastname']" type="text" class="form-control bg-grey" placeholder="Last Name" />
                                <span class="text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-6">
                              <div class="select-wrapper">
                                <select class="form-control" id="country" name="country" v-model="nationality" @change="getNation" :disabled="ndisabled == 0">
                                  <option value="">Select Nationality</option>
                                  <option v-for="c in countries" :key="c.Code+'-'+c.Name" :value="c.Code+'-'+c.Name">{{c.Name}}</option>
                                </select>
                                <span v-if="isActive" v-bind:class="{ active: isActive, 'text-danger': hasError }" class="text-danger">This field is required</span>
                              </div>
                            </div>
                            <div class="col-sm-6">
                              <input class="form-control" placeholder="If Other, Please Specify" v-model="otherNationality" :disabled="odisabled == 1" @blur="getOther">
                              <span v-if="isActive" v-bind:class="{ active: isActive, 'text-danger': hasError }" class="text-danger">This field is required</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-12" v-if="odisabled == 0">
                              <ValidationProvider name="User Name" rules="required" v-slot="{ errors }">
                                <input v-model.trim="frmAccount['mobile']" type="number" class="form-control bg-grey" placeholder="Mobile Number" />
                                <span class="text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </div>
                            <div class="col-sm-12" v-else>
                              <VuePhoneNumberInput color="#dc3545" v-model="phoneNumber" :default-country-code="nationality.split('-')[0]" @update="results = JSON.stringify($event)" />
                              <span v-if="results && !JSON.parse(results).isValid" class="text-danger">Please enter valid number</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-12">
                              <div class="select-wrapper">
                                <select class="form-control" id="country" name="country" v-model="frmAccount['userRole']">
                                  <option value="">Select User Role</option>
                                  <option v-for="r in userRoles" :key="r.id" :value="r.id">{{r.displayName}}</option>
                                </select>
                                <span v-if="isActive" v-bind:class="{ active: isActive, 'text-danger': hasError }" class="text-danger">This field is required</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-12">
                              <input class="form-control" placeholder="Location Access" v-model="frmAccount['comment']">
                              <span v-if="isActive" v-bind:class="{ active: isActive, 'text-danger': hasError }" class="text-danger">This field is required</span>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-12">
                              <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                                <input v-model="frmAccount['email']" type="email" class="form-control bg-grey" placeholder="Email" autocomplete="new-nemail" />
                                <span class="text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group row" style="margin: 0px !important;margin-bottom: 10px !important;">
                            <div class="col-sm-6">
                              <ValidationProvider name="Password" rules="required|verify_password|min:8|max:16" v-slot="{ errors }" vid="confirmation">
                                <div class="input-group">

                                  <input v-model="frmAccount['password']" type="password" class="form-control bg-grey" placeholder="Password" id="password" autocomplete="new-paaaassword" />
                                  <div class="input-group-append">
                                    <span @click="showPass" class="input-group-text fa fa-eye bg-grey"></span>
                                  </div>
                                </div>
                                <span class="text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </div>
                            <div class="col-sm-6">
                              <ValidationProvider name="Confirm Password" rules="required|confirmed:confirmation" v-slot="{ errors }">
                                <input v-model="frmAccount['confirm_pass']" type="password" class="form-control bg-grey" placeholder="Confirm Password" />
                                <span class="text-danger">{{ errors[0] }}</span>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-12 mt-3">
                          <div class="row">
                            <div class="col-lg-12 col-sm-12">
                              <div class="row" style="margin: 0px !important;">
                                <div class="form-group mb-0">
                                  <div class="col text-left" style="padding-left: 11px;">
                                    <button type="submit" class="btn btn-primary black-btn color-white" style="padding: 6px 35px;float: right;margin-right: 0px;">Request</button>
                                  </div>
                                </div>
                                <div class="form-group mb-0">
                                  <div class="col text-right m-t-10px" style="">
                                    <a class="" @click="GotoSignin()" style="font-size: 14px;">Login</a>
                                  </div>
                                </div>
                                <div class="form-group mb-0">
                                  <div class="col text-right m-t-10px" style="">
                                    <a class="" @click="goToActivateAccount" style="font-size: 14px; color: #797979;">Activate Account</a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
  <training-footer></training-footer>
</div>
</template>

<script>
import {
  extend
} from 'vee-validate';
import ApiServices from '../service/ApiServices';
import trainingHeader from '../components/trainingHeader';
import trainingFooter from '../components/trainingFooter';
import $ from "jquery";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import country from './countries.js'
//Vue.component('vue-phone-number-input', VuePhoneNumberInput);

//password restrictions
extend('verify_password', {
  message: `{_field_} must contain at least: 1 uppercase, 1 lowercase, 1 no, and one special character`,
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
    return strongRegex.test(value);
  }
});
export default {
  props: {},
  components: {
    trainingHeader,
    trainingFooter,
    VuePhoneNumberInput
  },
  data() {
    return {
      frmAccount: {
        firstname: "",
        lastname: "",
        email: "",
        mobile: "",
        password: "",
        confirm_pass: "",
        nationality: "",
        userRole: "",
        comment: "",
        status: "Incomplete"
      },
      userRoles: [],
      otherNationality: "",
      nationality: "",
      settings: settings,
      countries: country.countryList(),
      odisabled: 0,
      ndisabled: 1,
      isActive: false,
      hasError: false,
      results: null,
      phoneNumber: '',
    };
  },
  methods: {
    getNation() {
      if (this.nationality == "") {
        this.isActive = true
        this.hasError = true
        this.odisabled = 0
      } else {
        this.odisabled = 1
        this.isActive = false
        this.hasError = false
      }
    },
    getOther() {
      if (this.otherNationality == "") {
        this.ndisabled = 1
        this.isActive = true
        this.hasError = true
      } else {
        this.ndisabled = 0
        this.isActive = false
        this.hasError = false
      }
    },
    showPass() {
      let passwordField = document.querySelector('#password')
      if (passwordField.getAttribute('type') === 'password') {
        passwordField.setAttribute('type', 'text')
      } else {
        passwordField.setAttribute('type', 'password')
      }
    },
    GotoSignin() {
      this.$router.push("/HomeIndia");
    },
    goToActivateAccount() {
      this.$router.push("/activate-india");
    },
    onSubmit() {
      //this.$root.loading = true;
      if (!this.isActive) {
        if (this.otherNationality != "") {
          this.frmAccount['nationality'] = this.otherNationality
        } else {
          this.frmAccount['nationality'] = this.nationality
        }
        if (this.otherNationality == "") {
          this.phoneNumber = JSON.parse(this.results)['formatInternational']
          this.frmAccount['mobile'] = this.phoneNumber
        }
        console.log(this.frmAccount, this.nationality)
        let headers = {
          Authorization: 'Basic YWRtaW46ZGlzdHJpY3Q='
        };
        // ApiServices.RestPostCall('api/avenir/subscribe/register', this.frmAccount).then(Response => {
        ApiServices.RestPostCall('api/avenir/register/request', this.frmAccount).then(Response => {
          this.$root.loading = false;
          if (Response.status && Response.status.toLowerCase() == "success") {
            this.$swal({
              text: Response.message
            }).then(() => {
              this.$router.push("/activate-india");
            });
          } else {
            this.$swal({
              text: Response.message
            });
          }
        }).catch(error => {
          this.$root.loading = false;
          this.$swal({
            text: error
          });
        });
      }
    },
    getUserRoles() {
      ApiServices.RestGetCall('api/userRoles?fields=displayName%2Cid%2C&order=name%3Aasc').then(response => {
        console.log("user roles", response)
        this.userRoles = response.userRoles
      })
    }
  },
  mounted() {
    this.getUserRoles()
  },
  updated() {}
};
</script>

<style lang="scss" scoped>
.createAccountIndiaPage{
  background-image: linear-gradient(0deg,rgba(0,0,0,.1),rgba(0,0,0,.1)),url(../assets/img/loginbg.jpg);
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
        height: 100vh;
    overflow: auto;
}
.mdgridviewpage-bg {
    background-color: transparent;
    // background: url("../assets/img/sign_bg.jpg") no-repeat;
    // background-size: cover;
    // background-position: center;
    min-height: 100vh;
    // padding: 20px 40px;
    // display: flex;
    // flex-direction: column;

    // justify-content: center;
    // align-items: center;

    position: relative;
    // padding-bottom: 15%;
}

body.green-theme .mdgridviewpage-bg {
    background-color: #006600;
    background: url("../assets/img/green-bg.jpg") no-repeat;
    background-size: cover;
    background-position: center;
    min-height: 100vh;
    padding: 20px 40px;
}
.mainform-holder {
    /*background: #fff;
  -webkit-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  -moz-box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  box-shadow: -2px 0px 5px 0px rgba(204, 204, 204, 1);
  border-radius: 10px;*/
    padding: 15px 5px;
}
.c-body {
    background-color: rgba(255, 255, 255, 0.78);
    padding-top: 10px !important;
    padding-bottom: 30px !important;
    // border-bottom-left-radius: 10px;
    // border-bottom-right-radius: 10px;
    /* border-top-left-radius: 10px;
  border-top-right-radius: 10px; */
    /* box-shadow: 0px 0px 3px rgba(53,53,53,0.26); */
    border-radius: 5px;
}

.card {
    background-color: transparent;
    box-shadow: 0 0 0 0 4px rgb(186, 186, 186) !important;
    border-radius: 10px;
    border: 0 !important;
    width: 500px;
}
.form-control {
    background: #efeeee !important;
    border-color: #f2f2f2;
    color: #171a22 !important;
    font-size: 14px !important;
    font-weight: 200;
    border: 1px solid #e9e9e9;
}
a {
    cursor: pointer;
    color: rgb(121, 121, 121);
}
a:hover {
    text-decoration: underline !important;
}
input:-internal-autofill-selected {
    background: #ddd !important;
    border-color: #f2f2f2 !important;
}
* {
    color: #4c4c4c;
}
label {
    font-weight: 200;
}
.card-header {
    border-bottom: 0;
    border-radius: 10px 10px 0 0 !important;
    padding: 8px 12px !important;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
}
.input-group {
    position: relative;
    margin-bottom: 0;
}
.input-group-append {
    position: absolute;
    right: 4px;
    top: 4px;
    .input-group-text {
        background-color: transparent !important;
        border: transparent;
        z-index: 9;
        cursor: pointer;
        color: #a3a3a3;
        padding: 0.175rem 0.75rem;

    }
}
select {
    -moz-appearance: none;
    /* Firefox */
    -webkit-appearance: none;
    /* Safari and Chrome */
    appearance: none;
    -moz-appearance: none !important;

}
.select-wrapper {
    position: relative;
}

.select-wrapper:after {
    font-family: FontAwesome;
    content: '\f0d7';
    font-size: 16px;
    position: absolute;
    top: 8px;
    right: 14px;
    color: #676767;
    pointer-events: none;
}
#password {
    padding-right: 36px;
    border-radius: 4px;
}
.navbar {
    background: #edd0f5!important;
}
.logoImage {
    display: flex;
    justify-content: center;
    position: absolute;
}
.logoImageDiv {
    position: relative;
    z-index: 9;
    // top: -100px;
    // padding: 10px 10px;
    // left: 0;
    // width: 175px;
    // height: 80px;
    top: -110px;
    padding: 10px;
    left: 0;
    width: 175px;
    height: 90px;
    background-color: rgba(255, 255, 255, 0.78);
    border-top-left-radius: 110px;
    border-top-right-radius: 110px;
    /* border: 10px solid gray; */
    border-bottom: 0;
}
.logoImageDiv img {
    position: absolute;
    top: 26px;
    left: 36px;
}
.headerTitle {
    font-size: 2rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.minText p {
    margin-bottom: 0;
    padding-top: 5%;
    font-size: 16px;
    margin-left: 0;
    color: #000;
}
.minText p span {
    display: block;
    color: #000;
}
// #footer .c_div .c_logo{
//   width: 15%;
// }
footer {
    background-color: #f6f0f8;
}
.globalconfigcontainer {
    display: flex;
    justify-content: center;
    align-items: center;
    // height: 80vh;
}
</style>
